<template>
  <section class="p-4 pb-2" data-test="pro-header-placeholder" aria-busy="true">
    <div class="flex min-h-8 items-center gap-1 motion-safe:animate-pulse">
      <div class="h-6 w-40 rounded bg-tint-60" />
      <div class="ml-2 h-6 w-28 rounded bg-tint-60" />
      <div class="h-6 w-20 rounded bg-tint-60" />
      <div class="ml-auto h-6 w-24 rounded bg-tint-60" />
      <div class="ml-1 h-6 w-32 rounded bg-tint-60" />
      <div class="ml-1 h-6 w-6 rounded bg-tint-60" />
      <div class="h-6 w-6 rounded bg-tint-60" />
    </div>
    <div class="mt-1 flex gap-2 motion-safe:animate-pulse">
      <div class="h-4 w-44 rounded bg-tint-60" />
      <div class="h-4 w-32 rounded bg-tint-60" />
      <div class="h-4 w-40 rounded bg-tint-60" />
    </div>
  </section>
</template>
